<template>
<div class="position-relative mt-3" id="insurerTable">

  <div class="actions text-right" id="insurerTable-addButtonDiv">
    <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="insurerTable-addInsurerButton">
      <span class="btn-icon" id="insurerTable-addInsurerSpan"><i class="fa fa-plus" aria-hidden="true" id="insurerTable-addInsurerData"></i></span>
      {{ 'ADD' | translate }}
    </button>
  </div>

  <vodal :show="showAddEditDialog"
         :width="400"
         :closeOnEsc="true"
         :closeOnClickMask="false"
         :customStyles="{'top': '80px', 'bottom': 'auto', 'height': 'auto'}"
         animation="rotate"
         @hide="closeDialog"
         id="insurerTable-showEditDialog">
    <insurer-add-edit-dialog :edited="editedRow"
                              :covers="covers"
                              :insurers="insurers"
                              @save="onSaveNew"
                              @update="onUpdate"
                              @close="closeDialog"
                              id="insurerTable-addEditInsurer"
    ></insurer-add-edit-dialog>
  </vodal>
  <table class="table table-striped table-hover" id="insurerTable-InsurerDataTable">
    <caption></caption>
    <tr>
      <th>Naam</th>
      <th>Omschrijving</th>
      <th>goid</th>
      <th>oid</th>
      <th> {{ 'BACKOFFICE_CODE_INCOMING' | translate }} </th>
      <th> {{ 'BACKOFFICE_CODE_OUTGOING' | translate }}</th>
      <th>Enabled</th>  
      <th></th>
    </tr>
    <template v-for="row in rows">
      <tr>
        <td>{{ row.name }}</td>
        <td>{{ row.description }}</td>
        <td>{{ row.goid }}</td>
        <td>{{ row.oid }}</td>
        <td>{{ row.afdCode }}</td>
        <td>{{ row.backofficeCodeIncoming }}</td>
        <td> {{ row.backofficeCodeOutgoing }}</td>
        <td>{{ row.enabled }}</td>
        <td id="insurerTable-tableButtons">
          <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" :id="'insurerTable-editRowButton-'+row.name">
            <span class="btn-icon" :id="'insurerTable-editRowButton-span'+row.name"><i class="fa fa-pencil" aria-hidden="true" :id="'insurerTable-editRowButton-data-'+row.name"></i></span>
          </button>
          <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)" :id="'insurerTable-deleteRowButton-'+row.name">
            <span class="btn-icon" :id="'insurerTable-deleteRowSpan-'+row.name"><i class="fa fa-trash-o" aria-hidden="true" :id="'insurerTable-deleteRowData-'+row.name"></i></span>
          </button>
        </td>
      </tr>
    </template>
  </table>
  <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
          @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
          </confirm-dialog>
</div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import InsurerAddEditDialog from './InsurerAddEditDialog';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { InsurerAddEditDialog, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      rows: [],
      newRows: [],
      editedRow: null,
      covers: [],
      insurers: [],
      showAddEditDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null
    }
  },
  beforeMount() {
    this.loadRows();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const insurerResponse = await this.rest.getAllInsurerRows();
      this.rows = insurerResponse.data;
    },
    async onSaveNew(row) {
      await this.rest.createInsurerRow(row);
      this.closeDialog();
      this.loadRows();
    },
    async onUpdate(row) {
      await this.rest.updateInsurerRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      this.editedRow = { ...row };
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteInsurerRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = false;
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .vue-table {
    border: 0;

    th, td {
      border-right: 0;
      border-bottom: 0;
      border-left: 0;
    }

    thead > tr > th {
      padding-right: .75rem;
      padding-left: 30px !important;
    }

    .arrow:before {
      bottom: 12px;
      right: auto;
      left: 12px;
      font-family: 'FontAwesome';
    }

    .icon-button {
      opacity: 0;
      transition: opacity .1s ease-out;
    }

    tr:hover .icon-button {
      opacity: 1;
    }
  }

  .actions {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 0;

    .icon-button {
      padding-right: 15px;
      padding-left: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/insurer/InsurerTable.vue